<template>
  <div>
    <Modal importStyle="App">
      <template #default>
        <div
          ref="reviewGalleryScrollContainer"
          @scroll="handleScroll"
          :class="`${classVariableName}-gallery-details-container`"
        >
          <div :class="`${classVariableName}-gallery-details-modal-header`">
            Photos from Customers ({{ imageCount }})
            <svg
              :class="`${classVariableName}-cursor-pointer ${classVariableName}-auto-margin-left`"
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="onClose"
            >
              <circle cx="14.5" cy="14.5" r="14.5" fill="#F4F4F4" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.6332 17.102C16.9259 17.3947 17.4016 17.3942 17.6949 17.1009C17.9883 16.8075 17.9887 16.3318 17.696 16.0391L15.6352 13.9783L17.7021 11.9114C17.9954 11.6181 17.9959 11.1424 17.7032 10.8496C17.4105 10.5569 16.9348 10.5574 16.6414 10.8507L14.5745 12.9176L12.515 10.8581C12.2223 10.5654 11.7466 10.5659 11.4533 10.8592C11.1599 11.1526 11.1594 11.6282 11.4522 11.921L13.5117 13.9805L11.4455 16.0467C11.1514 16.3408 11.1517 16.8157 11.4444 17.1085C11.7371 17.4012 12.2121 17.4014 12.5062 17.1074L14.5724 15.0412L16.6332 17.102Z"
                fill="#211A1E"
              />
            </svg>
          </div>
          <div :class="`${classVariableName}-gallery-details-modal-image-grid`">
            <div
              @click="()=>openReviewDetails(review)"
              v-for="review in reviews"
              :key="review.id"
              :class="`${classVariableName}-img-container`"
            >
              <img
                loading="lazy"
                :src="review.image.lowResUrl"
                alt="review image..."
                :class="`${classVariableName}-image ${classVariableName}-cursor-pointer`"
                :style="{ width: '112px', height: '112px' }"
              />
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { isEmpty, classVariableName, scrollRequired, emitEvent, getEventData } from "../../utils";
import CUSTOM_EVENTS from "../../constants";
import Modal from "../common/Modal.vue";

export default defineComponent({
  name: "galleryDetailsModalComponent",
  components: {
    Modal,
  },
  props: {
    product: Object,
    imageCount: Number,
    reviews: Array,
    onClose: Function,
    getNextPage: Function,
    loading: Boolean,
    openImageReviewDetailsModal: Function,
  },
  mounted() {},
  setup() {},
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    async handleScroll() {
      const scrollContainer = this.$refs.reviewGalleryScrollContainer;
      if (!this.loading && scrollRequired(scrollContainer)) {
        return await this.getNextPage(); // Replace with your function
      }
    },
    async openReviewDetails(review) {
      emitEvent(CUSTOM_EVENTS.REVIEWS_WITH_IMAGES_CLICK_ON_PAGE, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'image_gallery', this.product, null));
      await this.openImageReviewDetailsModal(review);
    }
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/Review.scss";
</style>
